import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_ACTIVITIES,
  GET_ACTIVITIES,
  CLEAR_ACTIVITIES,
  FLAG_ACTIVITY_ACTIVITY,
  GET_ACTIVITY,
  CLEAR_ACTIVITY,
} from '../types/mechanical-maintenance';
import { ACTIVITY_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_DELETE_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { ACTIVITY_PATH } from '../../config/paths';

const flagGettingActivities = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ACTIVITIES,
    payload: flag,
  });

const getActivities = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingActivities(true));
    const query = tableFilters;
    const url = `${ACTIVITY_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();

    dispatch({
      type: GET_ACTIVITIES,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingActivities(false));
  }
};

const clearActivities = () => (dispatch) => {
  dispatch({
    type: CLEAR_ACTIVITIES,
  });
};

const flagActivityActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ACTIVITY_ACTIVITY,
    payload: flag,
  });

const getActivity =
  async ({ activityId }) =>
  async (dispatch) => {
    try {
      dispatch(flagActivityActivity(true));
      const url = `${ACTIVITY_ENDPOINT}/${activityId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();
      dispatch({
        type: GET_ACTIVITY,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagActivityActivity(false));
    }
  };

const clearActivity = () => (dispatch) =>
  dispatch({
    type: CLEAR_ACTIVITY,
  });

const createNewActivity = async ({
  name,
  description,
  factor,
  factorType,
  activityType,
  companyAreaId,
  companyActivityId,
  materialList,
  activityTaskList,
  activityMaintenanceTaskList,
  maintenanceTaskMaterialActivityList,
  action,
}) => {
  const payload = {
    name,
    description,
    factor,
    factorType,
    activityType,
    companyAreaId,
    companyActivityId,
    materialList,
    activityTaskList,
    activityMaintenanceTaskList,
    maintenanceTaskMaterialActivityList,
    action,
  };
  const url = ACTIVITY_ENDPOINT;
  const promise = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });
  await isErrorResponse(promise);
  const activity = await promise.json();
  return activity;
};

const postActivity =
  async ({
    name,
    description,
    activityType,
    companyAreaId,
    companyActivityId,
    materialList,
    activityTaskList,
    activityMaintenanceTaskList,
    maintenanceTaskMaterialActivityList,
    action,
    maintenanceActivitySystemId,
    maintenanceActivitySubsystemId,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagActivityActivity(true));
      const response = await createNewActivity({
        name,
        description,
        activityType,
        companyAreaId,
        companyActivityId,
        materialList,
        activityTaskList,
        activityMaintenanceTaskList,
        maintenanceTaskMaterialActivityList,
        action,
        maintenanceActivitySystemId,
        maintenanceActivitySubsystemId,
      });
      if (response) {
        dispatch(push(`${ACTIVITY_PATH}/${response.id}`));
      }
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagActivityActivity(false));
    }
  };

const deleteActivity =
  async ({ activityId }) =>
  async (dispatch) => {
    try {
      dispatch(flagActivityActivity(true));
      const url = `${ACTIVITY_ENDPOINT}/${activityId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(ACTIVITY_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagActivityActivity(false));
    }
  };

const putActivity =
  async (
    activityId,
    {
      name,
      description,
      activityType,
      companyAreaId,
      companyActivityId,
      materialList,
      activityTaskList,
      activityMaintenanceTaskList,
      maintenanceTaskMaterialActivityList,
      action,
      maintenanceActivitySystemId,
      maintenanceActivitySubsystemId,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagActivityActivity(true));
      const payload = {
        id: activityId,
        name,
        description,
        activityType,
        companyAreaId,
        companyActivityId,
        materialList,
        activityTaskList,
        activityMaintenanceTaskList,
        maintenanceTaskMaterialActivityList,
        action,
        maintenanceActivitySystemId,
        maintenanceActivitySubsystemId,
      };
      const url = `${ACTIVITY_ENDPOINT}/${activityId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${ACTIVITY_PATH}/${activityId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagActivityActivity(false));
    }
  };

const postMaterialsByActivity = async (activityIds) => async (dispatch) => {
  try {
    dispatch(flagActivityActivity(true));

    const payload = activityIds;
    const url = `${ACTIVITY_ENDPOINT}/material`;
    const promise = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(payload),
    });
    await isErrorResponse(promise);
    const materials = await promise.json();
    return materials;
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagActivityActivity(false));
  }
  return null;
};

export {
  flagGettingActivities,
  getActivities,
  clearActivities,
  flagActivityActivity,
  getActivity,
  postActivity,
  clearActivity,
  deleteActivity,
  putActivity,
  createNewActivity,
  postMaterialsByActivity,
};
